export default "__VITE_ASSET__BXXAaEic__"